import Header from './layout/Header'
import Footer from './layout/Footer'
import UserBox from './layout/UserBox'
import AffixFuns from './layout/AffixFuns'
import MessageTip from './layout/MessageTip'

import Login from './login/Login'
import Forgot from './login/Forgot'
import Reg from './login/Reg'
import SimpleReg from './login/SimpleReg'
import PasswordIntensity from './login/PasswordIntensity'
import Poptip from './login/Poptip'

import Avatar from './Avatar'
import CodeGetter from './CodeGetter'
import OpenShop from './openShop/OpenShop'
import PathBar from './PathBar'

export {
  Header,
  Footer,
  UserBox,
  AffixFuns,
  MessageTip,
  Login,
  Forgot,
  Reg,
  SimpleReg,
  PasswordIntensity,
  Poptip,
  Avatar,
  CodeGetter,
  OpenShop,
  PathBar
}



// WEBPACK FOOTER //
// ./src/commons/components/index.js